<div class="node-list-container">
    <div class="d-flex flex-horizontal">
        <div class="d-flex flex-vertical flex-grow-1 node-list-parameters">
            <div class="parameter">
                <span class="form-field-header">Node state</span>
                <select [(ngModel)]="activated" class="w-100" (change)="onParametersChanged()">
                    <option [ngValue]="undefined">All</option>
                    <option [ngValue]="true">Connected</option>
                    <option [ngValue]="false">Disconnected</option>
                </select>
            </div>
            <div class="parameter">
                <span class="form-field-header">Validation</span>
                <select [(ngModel)]="validated" class="w-100" (change)="onParametersChanged()">
                    <option [ngValue]="undefined">All</option>
                    <option [ngValue]="true">Validated</option>
                    <option [ngValue]="false">Not validated</option>
                </select>
            </div>
            <div class="parameter">
                <span class="form-field-header">Order</span>
                <select [(ngModel)]="order" class="w-100" (change)="onParametersChanged()">
                    <option [ngValue]="'RecentFirst'">Recent node activity</option>
                    <option [ngValue]="'OlderFirst'">Older node activity</option>
                    <option [ngValue]="'Id'">ID ascending</option>
                    <option [ngValue]="'IdDescending'">ID descending</option>
                    <option [ngValue]="'Status'">Earlier node phases</option>
                    <option [ngValue]="'StatusDescending'">Final node phases</option>
                </select>
            </div>
        </div>
        <app-paginator #nodeListPaginator (pageChange)="loadNodes()"></app-paginator>
    </div>
    <div class="node-list-table mt-2 pb-3">
        <span class="no-nodes-found" *ngIf="nodes === undefined || nodes.length === 0">0 nodes found</span>
        <div (click)="viewNodeLifecycle(node)" (keydown)="viewNodeLifecycle(node)" class="node-list-row-wrapper" *ngFor="let node of nodes" [ngClass]="nodeIsActive(node.lastUploadTimestamp) ? 'active' : ''">
            <div *ngIf="nodeIsActive(node.lastUploadTimestamp)" class="header-wrapper">
                <span class="header-active">connected</span>
            </div>
            <div class="node-list-row">
                <div class="form-field-header node-id">
                    <span>{{node.id}}</span>
                    <div class="node-highlights">
                        <mat-icon (click)="goToNodeHistory(node.id)" (keydown)="goToNodeHistory(node.id)" click-stop-propagation title="View node history" class="node-history-icon status-icon">history</mat-icon>
                        <div>
                            <div class="badge-validation" *ngIf="!node.validated">Not validated</div>
                            <div class="badge-validation success" *ngIf="!!node.validated">Validated</div>
                        </div>
                    </div>
                </div>
                <div>{{node.name}}</div>
                <div [title]="node.nodeIdentifier" class="node-identifier">{{node.nodeIdentifier}}</div>
                <div class="node-data">
                    <span class="node-data-title">Address</span>
                    <span class="node-data-value">{{node.address}}</span>
                </div>
                <div class="node-data">
                    <span class="node-data-title">Port</span>
                    <span class="node-data-value">{{node.port}}</span>
                </div>
                <div class="node-data">
                    <span class="node-data-title">Status</span>
                    <span class="node-data-value">{{getNodeStatus(node.status?.toString())}}</span>
                </div>
                <div class="node-data">
                    <span class="node-data-title">Last time active</span>
                    <span 
                        class="node-data-value" [title]="node.lastUploadTimestamp ? (node.lastUploadTimestamp | date: 'dd/MM/yyyy HH:mm:ss') : '-'"
                        [ngClass]="nodeIsActive(node.lastUploadTimestamp) ? 'text-success' : 'text-danger'"
                        >{{node.lastUploadTimestamp ? (node.lastUploadTimestamp | dateAgo) : '-' }}</span>
                </div>
                <div class="node-buttons">
                    <button *ngIf="nodeIsActive(node.lastUploadTimestamp)" click-stop-propagation class="button w-100 outline mini wide" (click)="configureNode(node)">
                        <span *ngIf="nodeCanBeConfigured(node)">Configure</span>
                        <span *ngIf="!nodeCanBeConfigured(node)">View config</span>
                    </button>
                    <button click-stop-propagation class="button w-100 mini wide" *ngIf="node.validated"
                        (click)="unvalidate(node)">Unvalidate</button>
                    <button click-stop-propagation class="button w-100 mini wide" *ngIf="!node.validated"
                        (click)="validate(node)">Validate</button>
                </div>
            </div>
        </div>
    </div>
</div>
